/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
import styled from "styled-components";
import { Radio as BaseRadio } from "antd";

import color from "../_style/color";

// helper - styled components
const Group = styled(BaseRadio.Group)`
  .ant-radio-button-wrapper {
    margin-right: 8px;
    :last-child {
      margin: 0;
    }
  }
  overflow: hidden;

  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled) {
    border-color: ${color.gainsboro};
    color: ${color.primary};
    background: ${color.aliceBlue};
  }
  .ant-radio-button-wrapper-checked:not([class*=" ant-radio-button-wrapper-disabled"]).ant-radio-button-wrapper {
    border-color: ${color.gainsboro};
  }
  .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled)::before {
    background-color: ${color.gainsboro};
  }
`;

const Button = styled(BaseRadio.Button)`
  border-color: ${color.gainsboro};
  :hover {
    color: ${color.primary};
    background: ${color.aliceBlue};
  }
`;

const Radio = BaseRadio;
Radio.Group = Group;
Radio.Button = Button;

export default Radio;
